var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHomeActive = function SvgHomeActive(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.26426 0.178546C9.54434 -0.0595152 9.95567 -0.0595152 10.2357 0.178545L18.2077 6.95472C18.5976 7.28609 18.9129 7.7545 19.1302 8.22417C19.3474 8.69375 19.5 9.23673 19.5 9.74693V17.3969C19.5 18.5634 18.5591 19.5 17.3994 19.5H12.45C12.0358 19.5 11.7 19.1642 11.7 18.75V13.2H7.8V18.75C7.8 19.1642 7.46421 19.5 7.05 19.5H2.09739C0.937716 19.5 0 18.5617 0 17.3969V9.74693C0 9.23692 0.153221 8.6935 0.370445 8.22407C0.58771 7.75455 0.902967 7.28565 1.29229 6.95472L9.26426 0.178546ZM9.75 1.73433L2.26377 8.09763C2.08533 8.2493 1.88657 8.51945 1.73176 8.854C1.57691 9.18864 1.5 9.51429 1.5 9.74693V17.3969C1.5 17.7359 1.76878 18 2.09739 18H6.3V12.45C6.3 12.0358 6.63579 11.7 7.05 11.7H12.45C12.8642 11.7 13.2 12.0358 13.2 12.45V18H17.3994C17.7315 18 18 17.7342 18 17.3969V9.74693C18 9.51324 17.9232 9.18782 17.7688 8.85397C17.6144 8.52023 17.4157 8.2502 17.2362 8.09763L9.75 1.73433Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-active.4628f4db.svg";
export { ForwardRef as ReactComponent };